import React, { useState } from 'react';
import { Layout, Menu, Button, Typography, Avatar, Dropdown } from 'antd';
import {
  ScanOutlined,
  HistoryOutlined,
  BarChartOutlined,
  LogoutOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Routes, Route, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import CouponRedemption from './CouponRedemption';
import SalesRecords from './SalesRecords';
import SalesStatistics from './SalesStatistics';
import Footer from '../Common/Footer';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const SalesDashboard: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="profile" icon={<UserOutlined />}>
        {user?.username}
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  const menuItems = [
    {
      key: '/sales',
      icon: <ScanOutlined />,
      label: <Link to="/sales">优惠券核销</Link>,
    },
    {
      key: '/sales/records',
      icon: <HistoryOutlined />,
      label: <Link to="/sales/records">核销记录</Link>,
    },
    {
      key: '/sales/statistics',
      icon: <BarChartOutlined />,
      label: <Link to="/sales/statistics">核销统计</Link>,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        collapsible 
        collapsed={collapsed} 
        onCollapse={setCollapsed}
        theme="light"
        width={250}
      >
        <div style={{ 
          padding: '16px', 
          textAlign: 'center',
          borderBottom: '1px solid #f0f0f0'
        }}>
          <Title level={4} style={{ margin: 0, color: '#52c41a' }}>
            {collapsed ? '核销' : '优惠券核销系统'}
          </Title>
        </div>
        <Menu
          theme="light"
          defaultSelectedKeys={['/sales']}
          mode="inline"
          items={menuItems}
          style={{ borderRight: 0 }}
        />
      </Sider>
      
      <Layout>
        <Header style={{ 
          background: '#fff', 
          padding: '0 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #f0f0f0'
        }}>
          <Title level={3} style={{ margin: 0, color: '#333' }}>
            销售端控制台
          </Title>
          
          <Dropdown overlay={userMenu} trigger={['click']}>
            <Button type="text" style={{ height: 'auto', padding: '4px 8px' }}>
              <Avatar size="small" icon={<UserOutlined />} />
              <span style={{ marginLeft: 8 }}>{user?.username}</span>
            </Button>
          </Dropdown>
        </Header>
        
        <Content style={{ margin: '24px', background: '#fff' }}>
          <Routes>
            <Route index element={<CouponRedemption />} />
            <Route path="records" element={<SalesRecords />} />
            <Route path="statistics" element={<SalesStatistics />} />
          </Routes>
        </Content>
        <Footer />
      </Layout>
    </Layout>
  );
};

export default SalesDashboard;